import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Agenda from "@/components/site/Agenda";
import Speakers from "@/components/site/Speakers";
import FeaturedLeaders from "@/components/site/FeaturedLeaders";
import Glimpses from "@/components/site/Glimpses";
import Registration from "@/components/site/Registration";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  // Fix deep-link hash scrolling (e.g. /#registration from an email).
  // The browser's native hash-scroll fires before lazy-loaded images
  // change page height, so we re-scroll after first paint AND after
  // window.load to ensure the target section lands accurately.
  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (!hash || hash.length < 2) return;
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView({ block: "start" });
    };

    const t1 = setTimeout(scrollToHash, 80);
    const t2 = setTimeout(scrollToHash, 500);
    const t3 = setTimeout(scrollToHash, 1500);
    window.addEventListener("load", scrollToHash);
    window.addEventListener("hashchange", scrollToHash);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      window.removeEventListener("load", scrollToHash);
      window.removeEventListener("hashchange", scrollToHash);
    };
  }, []);

  return (
    <div data-testid="landing-page" className="bg-white text-[#111]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Agenda />
        <Speakers />
        <FeaturedLeaders />
        <Glimpses />
        <Registration />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
